import clsx from 'clsx'

import marketplaceDemoGif from 'assets/gif/marketplace_demo.gif'
import {
  BOOK_A_DEMO_URL,
  MARKETPLACE_KNOW_MORE_URL,
} from 'utils/constants/website_urls'

import s from './MarketplaceBanner.module.css'

const MarketplaceBanner = () => {
  return (
    <div className={s.wrapper}>
      <div className={s.body}>
        <span className={s.sparkle}>&#10024;</span>
        <div className={s.content}>
          <div>
            <span className={s.title}>EXPERT TALENT NETWORK</span>
            <span className={s.header}>
              On-demand experts for high-quality content
            </span>
          </div>
          <span className={s.bodyContent}>
            Top 3% curated experts with high skill and domain competence,
            scouted for your most important project.
          </span>
          <div className={s.buttonsContainer}>
            <button
              className={clsx(s.button, s.buttonLight)}
              onClick={() => window.open(BOOK_A_DEMO_URL, '_blank')}
            >
              Contact Sales
            </button>
            <button
              className={clsx(s.button, s.buttonDark)}
              onClick={() => window.open(MARKETPLACE_KNOW_MORE_URL, '_blank')}
            >
              Know More
            </button>
          </div>
        </div>
        <div className={s.image}>
          <img
            className={s.gif}
            loading="lazy"
            src={marketplaceDemoGif}
            alt="marketplace demo"
          />
        </div>
      </div>
    </div>
  )
}

export default MarketplaceBanner
